import React, { useEffect, useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataImmo } from '../../../data/modules/logistic-header';
import { DataGrid } from '@material-ui/data-grid';
import { Autocomplete, Button, DialogActions, DialogContent, DialogTitle, Grid, Paper, IconButton, TextField, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import Title from '../../../components/Title';
import { Dialog, FormControl, makeStyles, Typography } from '@material-ui/core';
import Spacer from '../../../components/Spacer';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Message from '../../tools/Message';
import VehicleService from '../../../services/VehicleService';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px",
    marginTop: "2%",
    height: "60%",
    boxShadow: "box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
  },
  btn: {
    margin: "1% 0.25% 1% 0.25%",
    fontWeight: 600,
  },
}));

const FuelParameter = () => {
    const classes = useStyles();
    const [rows, setRows] = useState([]);
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        color: "green",
        messageInfo: "",
    });
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [formValues, setFormValues] = useState({
        fuel_price_id: 0,
        fuel_type: 'Essence',
        price_per_liter: 0,
        is_active: "1",
    });

    const { open, color, messageInfo } = message;
    const columns = [
        { field: 'fuelType', headerName: 'Type de Carburant', width: 220 },
        { field: 'pricePerLiter', headerName: 'Prix par Litre', width: 220 },
        { field: 'is_active', headerName: 'Actif', width: 150, renderCell: (params) => (
            <Typography variant="body2" color={params.row.is_active == "1" ? "success" : "error"}>
                {params.row.is_active == "1" ? "Oui" : "Non"}
            </Typography>
        )},
        { field: 'lastUpdated', headerName: 'Dernière Mise à Jour', width: 400 },
        { field: 'actions', headerName: 'Actions', width: 150, renderCell: (params) => (
            <>
           <IconButton 
           onClick={() => {
                handleEdit(params.row);
              }}
              size="small"
              color='primary'
              sx={{ marginRight: "20px" }}
              title="Modifier prix par litre">
            <EditIcon />
           </IconButton>
           <IconButton
              onClick={() => {
                handleDelete(params.row);  
              }}
              color='error'
              size="small"
                title="Supprimer le carburant">
            <DeleteIcon />
           </IconButton>
           </>
        )},
    ];

    const fetchData = async () => {
            setOpenLoadingSimpleBackdrop(true);
            try {

                const response = await VehicleService.getFuelParameters();
                if (response.status && response.data && response.data.length > 0) {
                    const formattedRows = response.data.map((item, index) => ({
                        id: index + 1,
                        fuel_price_id: item.fuel_price_id,
                        fuelType: item.fuel_type,
                        pricePerLiter: item.price_per_liter,
                        lastUpdated: item.updated_at ? new Date(item.updated_at).toLocaleDateString() : new Date(item.created_at).toLocaleDateString(),
                        is_active: item.is_active,
                    }));
                    setRows(formattedRows);
                } else {
                    setMessage({
                        open: true,
                        color: "green",
                        messageInfo: "Aucun carburant trouvé.",
                    });
                }
            } catch (error) {
                setMessage({
                    open: true,
                    color: "red",
                    messageInfo: error.message || "Erreur lors de la récupération des carburants.",
                });
            } finally {
                setOpenLoadingSimpleBackdrop(false);
            }
        };

    useEffect(() => {
        fetchData();
    }, []);

    const handleOpenDialog = () => {
        setOpenDialog(true);
    }

    const handleEdit = (row) => {
        setSelectedRow(row);
        setFormValues({
            fuel_price_id: row.fuel_price_id || 0,
            fuel_type: row.fuelType,
            price_per_liter: row.pricePerLiter,
            is_active: row.is_active,
        });
        setOpenDialog(true);
    }
    

    const handleCloseMessage = () => {
        setMessage({ ...message, open: false });
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setFormValues({
            fuel_price_id: 0,
            fuel_type: 'Essence',
            price_per_liter: 0,
        });
        setSelectedRow(null);
    }

    const handleDelete = (row) => {
        setSelectedRow(row);
        setFormValues({
            fuel_price_id: row.fuel_price_id || 0,
            fuel_type: row.fuelType,
            price_per_liter: row.pricePerLiter,
        });
        setOpenDeleteDialog(true);
    }

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        setSelectedRow(null);
        setFormValues({
            fuel_price_id: 0,
            fuel_type: 'Essence',
            price_per_liter: 0,
        });
    }

    const handleDeleteConfirm = async () => {
        setOpenLoadingSimpleBackdrop(true);
        try {
            const response = await VehicleService.deleteFuelParameter(formValues.fuel_price_id);
            if (response) {
                setMessage({
                    open: true,
                    color: "green",
                    messageInfo: "Carburant supprimé avec succès.",
                });
                fetchData();
            } else {
                setMessage({
                    open: true,
                    color: "red",
                    messageInfo: "Erreur lors de la suppression du carburant.",
                });
            }
        } catch (error) {
            setMessage({
                open: true,
                color: "red",
                messageInfo: error.message || "Erreur lors de la suppression du carburant.",
            });
        } finally {
            setOpenLoadingSimpleBackdrop(false);
            handleCloseDeleteDialog();
        }
    }

    const handleSave = () => {
        setOpenLoadingSimpleBackdrop(true);
        VehicleService.saveFuelParameter(formValues)
            .then(response => {
                if (response) {
                    setMessage({
                        open: true,
                        color: "green",
                        messageInfo: "Carburant ajouté avec succès.",
                    });
                    fetchData(); 
                } else {
                    setMessage({
                        open: true,
                        color: "red",
                        messageInfo: "Erreur lors de l'ajout du carburant.",
                    });
                }
            })
            .catch(error => {
                setMessage({
                    open: true,
                    color: "red",
                    messageInfo: error.message || "Erreur lors de l'ajout du carburant.",
                });
            })
            .finally(() => {
                setOpenLoadingSimpleBackdrop(false);
                handleCloseDialog();
            });
    }
  return (
    <MainContainer {...headerDataImmo}>
        <LoadingSimpleBackdrop open={openLoadingSimpleBackdrop} />
        <Message open={open}
        color={color}
        message={messageInfo}
        onClose={handleCloseMessage} />
        <Grid container item xs={12}>
        <Button
          variant="contained"
          color="error"
          onClick={handleOpenDialog}
          style={{ fontWeight: 600 }}
        >
          CREER
        </Button>
        <Spacer x={2} />
        </Grid>
        <Grid item xl={12} md={12}>
                  <Paper className={classes.paper} variant="outlined">
                    <Title>Paramétrage des Carburants</Title>
        <div style={{ padding: '4px' }}>
            <DataGrid 
                rows={rows}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                autoHeight
                disableSelectionOnClick
                style={{ marginTop: '20px', height: '400px' }}
            />
        </div>
        </Paper>
        </Grid>

        <Dialog 
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="form-dialog-title"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="form-dialog-title">Ajouter le prix par litre du carburant</DialogTitle>
            <DialogContent>
                <Spacer y={2} />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                       <Autocomplete
                            options={['Essence', 'Diesel']}
                            renderInput={(params) => <TextField {...params} label="Type de Carburant" variant="outlined" size='small' />}
                            fullWidth
                            onChange={(event, value) => { setFormValues({ ...formValues, fuel_type: value }) }}
                            value={formValues.fuel_type}
                        />
                    </Grid>
                    <Grid item xs={12}>
                            <Grid container spacing={2}>
                        <Grid item xs={2}>
                        <FormLabel>Actif :</FormLabel>
                        </Grid>
                        <Grid item xs={6}>
                         <FormControl component="fieldset" size='small'>
                        <RadioGroup value={formValues.is_active} onChange={ (e) => setFormValues({ ...formValues, is_active: e.target.value }) } row>
                            <FormControlLabel value="1" control={<Radio />} label="Oui" />
                            <FormControlLabel value="0" control={<Radio />} label="Non" />
                        </RadioGroup>
                        </FormControl>
                        </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            id="pricePerLiter"
                            label="Prix par Litre en Ariary"
                            type="number"
                            fullWidth
                            size='small'
                            onChange={(e) => setFormValues({ ...formValues, price_per_liter: e.target.value })}
                            value={formValues.price_per_liter}
                        />
                    </Grid>
        
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleCloseDialog()} color="error" variant='contained' >
                    Annuler
                </Button>
                <Button onClick={() => handleSave()} color="primary" variant='contained'>
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openDeleteDialog && selectedRow !== null}
            onClose={handleCloseDialog}
            aria-labelledby="form-dialog-title"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="form-dialog-title">Supprimer le prix par litre du carburant</DialogTitle>
            <DialogContent>
                <Spacer y={2} />
                <Grid container spacing={2}>
                    <Typography variant="body1" gutterBottom>
                        Êtes-vous sûr de vouloir supprimer le carburant <strong>{selectedRow ? selectedRow.fuelType : ''}</strong> ?
                        </Typography>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleCloseDeleteDialog()} color="error" variant='contained'>
                    Annuler
                </Button>
                <Button onClick={() => handleDeleteConfirm()} color="primary" variant='contained'>
                    Confirmer
                </Button>
            </DialogActions>
        </Dialog>
    </MainContainer>
  );
}

export default FuelParameter;